export const ADD_PROJECT = "ADD_PROJECT";
export const UPDATE_PROJECT = "UPDATE_PROJECT";
export const REMOVE_PROJECT = "REMOVE_PROJECT";

export const ADD_QUESTION_INTO_PROJECT = "ADD_QUESTION_INTO_PROJECT";
export const REMOVE_QUESTION_FROM_PROJECT = "REMOVE_QUESTION_FROM_PROJECT";

export const addProject = (project) => {
  return {
    type: ADD_PROJECT, 
    project
  }
}

export const addQuestionIntoProject = (projectID, question) => {
  return {
    type: ADD_QUESTION_INTO_PROJECT, 
    projectID,
    question
  }
}


export const updateProject = (project) => {
  return {
    type: UPDATE_PROJECT, 
    project
  }
}

export const removeProject = (project) => {
  return {
    type: REMOVE_PROJECT, 
    project
  }
}

export const removeQuestionFromProject = (projectID, question) => {
  return {
    type: REMOVE_QUESTION_FROM_PROJECT, 
    projectID,
    question
  }
}


// WEBPACK FOOTER //
// ./src/actions/projects.js